import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class RegisteredRecordMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.registeredRecord.registeredRecordMapperError"));

        Object.setPrototypeOf(this, RegisteredRecordMapperError.prototype);
    }
}